// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3JpRv","large":"styles_large__1whjb"};